import { requestParentNavigation } from '../postMessage';

// A second tap while the host is still deciding must not post a second
// request or navigate twice.
let isPending = false;

/**
 * Leaves the game for the casino lobby. The host gets the first say
 * (`navigate_lobby`) — app WebViews route the player themselves. If it
 * doesn't claim it, navigates the TOP window — the player is done here, so
 * the whole page goes, not just the iframe. If the host sandbox forbids top
 * navigation, falls back to navigating the iframe itself so the tap never
 * dead-ends.
 */
export function goToLobby(url: string): void {
  if (isPending) return;
  isPending = true;
  void requestParentNavigation('navigate_lobby').then((isHandled) => {
    isPending = false;
    if (!isHandled) navigateToLobby(url);
  });
}

function navigateToLobby(url: string): void {
  try {
    (window.top ?? window).location.assign(url);
  } catch {
    window.location.assign(url);
  }
}
